import ApiService from '../services/apiService';

export const indexReliquidationBalancesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('get', '/reliquidation_balances', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const createReliquidationBalancesRequest = ({
  dispatch,
  params,
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('post', '/reliquidation_balances', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const exportReliquidationBalancesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll',
  format = '.xlsx'
}) => {
  ApiService.request('get', `/reliquidation_balances/export${format}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const importReliquidationBalancesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('post', '/reliquidation_balances/import', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const importTemplateReliquidationBalancesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('get', '/reliquidation_balances/import_template', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const updateReliquidationBalancesRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) => {
  ApiService.request('put', `/reliquidation_balances/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const preImportReliquidationBalancesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('get', '/reliquidation_balances/pre_import', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const destroyReliquidationBalancesRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) => {
  ApiService.request('delete', `/reliquidation_balances/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const massiveDestroyReliquidationBalancesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('delete', '/reliquidation_balances/massive_destroy', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};
